
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.53 6.53a.75.75 0 000-1.06L15.757.697a.75.75 0 00-1.06 1.06L18.939 6l-4.242 4.243a.75.75 0 001.06 1.06L20.53 6.53zM0 6.75h20v-1.5H0v1.5z"}})])
          )
        }
      }
    